import { Box, Flex, Grid, Text } from '@chakra-ui/react';
import { useI18nLn } from '~/hooks/store';
import { BenefitPrize } from '~/types/resources/benefitPrize';
import type { GachaDetail } from '~/types/resources/gachaDetail';
import { GrantedItem } from '~/types/resources/grantedItem';
import { TextBorder } from '../common/TextBorder';
import { CollectionBenefitItem } from './CollectionBenefitItem';

type Props = {
  gachaDetail: GachaDetail;
  grantedBenefits: GrantedItem['benefits'];
  benefitOnOpen: () => void;
  setBenefitPrize: (newBenefitPrize: BenefitPrize) => void;
};

export const CollectionBenefitList: React.FC<Props> = (props: Props) => {
  const { t } = useI18nLn();
  const benefitTriggerss = props.gachaDetail.benefit_triggers ?? [];
  if (benefitTriggerss.length < 1) return null;

  return (
    <>
      {benefitTriggerss.length > 0 && (
        <>
          <Box h="56px" />
          <Flex px="16px" w="full">
            <Text
              fontSize="22px"
              fontWeight="bold"
              lineHeight="36px"
              textAlign="center"
              w="full"
            >
              {t('pages.gacha.purchase_benefits')}
            </Text>
          </Flex>
          <Box h="16px" />
        </>
      )}
      {Object.values(benefitTriggerss).map((benefitTrigger, index) => {
        const benefitTriggerPrizes = benefitTrigger.prizes;

        if (benefitTriggerPrizes.length < 1) return null;
        return (
          <Flex flexDir="column" w="full" key={`${benefitTrigger}_${index}`}>
            <TextBorder text={benefitTrigger.name} />
            <Box h="16px" />
            <Grid
              templateColumns="repeat(3, 1fr)"
              gap={0}
              justifyContent="center"
            >
              {Object.values(benefitTriggerPrizes).map(
                (benefitPrize, index) => {
                  return (
                    <CollectionBenefitItem
                      key={`benefit_${index}`}
                      benefitPrize={benefitPrize}
                      grantedBenefits={props.grantedBenefits}
                      benefitOnOpen={props.benefitOnOpen}
                      setBenefitPrize={props.setBenefitPrize}
                    />
                  );
                }
              )}
            </Grid>
            <Box h="24px" />
          </Flex>
        );
      })}
      <Box h="8px" />
    </>
  );
};
